import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const ImpersonateModal = ({ account, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleImpersonate = async () => {
    setLoading(true);
    try {
      // Store impersonation data in sessionStorage (admin session stays active)
      sessionStorage?.setItem('superAdminImpersonating', JSON.stringify({
        targetEmail: account?.email,
        targetName: account?.displayName || account?.email,
        targetId: account?.id,
        targetPlan: account?.plan || 'free',
      }));

      // Navigate to dashboard as the impersonated user view
      navigate('/dashboard');
      onClose?.();
    } catch (err) {
      console.error('Impersonation error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-lg shadow-elevation-lg w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <Icon name="LogIn" size={20} className="text-amber-600" />
            </div>
            <div>
              <h3 className="text-lg font-heading font-semibold text-foreground">Login as User</h3>
              <p className="text-xs text-muted-foreground">Impersonate this account</p>
            </div>
          </div>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground transition-smooth">
            <Icon name="X" size={22} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          {/* Account info */}
          <div className="flex items-center gap-3 p-3 bg-muted/30 rounded-lg">
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="User" size={18} className="text-primary" />
            </div>
            <div>
              <p className="font-medium text-foreground text-sm">{account?.displayName || account?.email}</p>
              <p className="text-xs text-muted-foreground">{account?.email}</p>
            </div>
            <span className="ml-auto px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700 capitalize">
              {account?.plan || 'free'}
            </span>
          </div>

          {/* Warning */}
          <div className="flex items-start gap-2 px-4 py-3 rounded-md bg-amber-50 border border-amber-200 text-amber-800 text-sm">
            <Icon name="AlertTriangle" size={16} className="mt-0.5 flex-shrink-0" />
            <span>You will be viewing the dashboard as this user. A <strong>"Return to Admin"</strong> button will appear in the sidebar so you can switch back.</span>
          </div>

          <div className="flex justify-end gap-3 pt-1">
            <Button variant="outline" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button
              onClick={handleImpersonate}
              loading={loading}
              className="bg-amber-600 hover:bg-amber-700 text-white border-amber-600"
            >
              <Icon name="LogIn" size={16} className="mr-2" />
              Login as User
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpersonateModal;
